import classes from "../MoodleWizardPopup.module.css"

const MoodleStep = ({ number, title, icon, children }) => (
    <div className={classes.StepRow}>
        <div className={classes.StepNumber}>{number}</div>
        <div className={classes.StepContent}>
            <img src={icon} alt="" className={classes.Icon} />
            <span className={classes.StepText}>{title}</span>
            {children}
        </div>
    </div>
);
export default MoodleStep